const goAppLink = function(kind,link) {
    // kind 类型 theme link scroll
    // link 后面拼接的url参数
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // let len = location.href.indexOf('#');
    // let host = location.href;
    // if(len) {host = host.substring(0,len);}
    let host = 'http://quote.aigupiao.com/stock_m.php';
    if (isAndroid) {
        location.href = `${host}#AiGuPiao_jump_kind=${kind}${link}`;    
    } else if (isiOS) {
        location.href = `${host}#igpFunToAppJump_kind=${kind}${link}`; 
    }
}
export default goAppLink;